/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptRecommendationDetailListRequest {
    getFixupPrototypeFunction() { return PromptRecommendationDetailListRequest.fixupPrototype; }

    static newInstance(model: Partial<PromptRecommendationDetailListRequest>): PromptRecommendationDetailListRequest {
        let obj = Object.assign(new PromptRecommendationDetailListRequest(), model);
        PromptRecommendationDetailListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptRecommendationDetailListRequest>): PromptRecommendationDetailListRequest {
        if (!model) return null;
        return PromptRecommendationDetailListRequest.newInstance(<PromptRecommendationDetailListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptRecommendationDetailListRequest) {
        if (!obj) return;

        models.PromptRecommendationDetailListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptRecommendationDetailListRequest): boolean {
        Object.setPrototypeOf(obj, PromptRecommendationDetailListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.PromptRecommendationDetailRequest.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.PromptRecommendationListRequestSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.PromptRecommendationListRequestSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.PromptRecommendationDetailRequest;

}
